<template>
  <div class="table-wrap">
    <div class="table-content-item" :style="[{width: widthCup}]">
      <div class="content-label" :style="[{width: labelWidthCup}]">
        {{label}}
      </div>
      <div class="content">
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容这是内容
        这是内容这是内容
      </div>
    </div>
    <div class="table-content-item" :style="[{width: widthCup}]">
      <div class="content-label" :style="[{width: labelWidthCup}]">
        {{label}}
      </div>
      <div class="content">
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容这是内容
        这是内容这是内容
      </div>
    </div>
    <div class="table-content-item" :style="[{width: widthCup}]">
      <div class="content-label" :style="[{width: labelWidthCup}]">
        {{label}}
      </div>
      <div class="content">
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容这是内容
        这是内容这是内容
      </div>
    </div>
    <div class="table-content-item" :style="[{width: widthCup}]">
      <div class="content-label" :style="[{width: labelWidthCup}]">
        {{label}}
      </div>
      <div class="content">
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容这是内容
        这是内容这是内容
      </div>
    </div>
    <div class="table-content-item" :style="[{width: widthCup}]">
      <div class="content-label" :style="[{width: labelWidthCup}]">
        {{label}}
      </div>
      <div class="content">
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容这是内容
        这是内容这是内容
      </div>
    </div>
    <div class="table-content-item" :style="[{width: widthCup}]">
      <div class="content-label" :style="[{width: labelWidthCup}]">
        {{label}}
      </div>
      <div class="content">
        这是内容这是内容这是内容这是内容
        这是内容这是内容
      </div>
    </div>
    <div class="table-content-item" :style="[{width: widthCup}]">
      <div class="content-label" :style="[{width: labelWidthCup}]">
        {{label}}
      </div>
      <div class="content">
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容
        这是内容这是内容这是内容这是内容这是内容
        这是内容这是内容
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "TableForm",
        components: {},
        directives: {},
        filters: {},
        mixins: [],
        props: {},
        data() {
            return {
              labelWidthCup: '120px',
              label: '姓名'
            }
        },
        computed: {
          widthCup() {
            return '33%'
          }
        },
        watch: {},
        methods: {}
    }
</script>

<style scoped>

  .table-wrap {
    --border-color: #B2B2B2;
    margin: 30px;
    height: 100%;
    border-left: 1px solid var(--border-color);
    border-top: 1px solid var(--border-color);
    line-height: 1.4;
    box-sizing: border-box;
  }
  .table-wrap .table-content-item {
    display: inline-block;
    flex-wrap: wrap;
    align-items: center;
    background-color: #EBEEF3;
    position: relative;
    border-bottom: 1px solid var(--border-color);
    vertical-align: top;
    height: 80px;
  }
  .table-wrap .table-content-item .content-label {
    background-color: #EBEEF3;
    text-align: center;
    font-weight: 700;
    float: left;
    /*position: absolute;*/
    /*left: 0;*/
    /*top: 0;*/
    /*bottom: 0;*/
  }
  .table-wrap .table-content-item .content-label ::after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .table-wrap .table-content-item .content-label-text {
      display: inline-block;
      vertical-align: middle;
      line-height: 1.4;
      width: 80%;
    margin-top: auto;
    }
  .table-wrap .table-content-item .content{
    height: 100%;
    border-right: 1px solid var(--border-color);
    border-left: 1px solid var(--border-color);
    width: calc(100% - 120px);
    float: left;
  }
</style>
